"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var TotalJackpot_1 = __importDefault(require("./TotalJackpot"));
var Tournament_1 = __importDefault(require("./Tournament"));
var WinOfTheMonth_1 = __importDefault(require("./WinOfTheMonth"));
var useTotalJackpot_1 = require("./TotalJackpot/useTotalJackpot");
var useTournament_1 = require("./Tournament/useTournament");
var useWinOfTheMonth_1 = require("./WinOfTheMonth/useWinOfTheMonth");
var Activity = function (_a) {
    var _b = _a.withHeader, withHeader = _b === void 0 ? false : _b, onClickJackpotHandler = _a.onClickJackpotHandler;
    var t = (0, next_intl_1.useTranslations)('translation');
    var jackpotData = (0, useTotalJackpot_1.useTotalJackpot)();
    var _c = (0, useTournament_1.useTournament)(), activeTournament = _c.activeTournament, tournamentToShow = _c.tournamentToShow;
    var _d = (0, useWinOfTheMonth_1.useWinOfTheMonth)(), currentGame = _d.currentGame, winData = _d.winData;
    if (!tournamentToShow ||
        !jackpotData ||
        !(winData === null || winData === void 0 ? void 0 : winData.win) ||
        !(currentGame === null || currentGame === void 0 ? void 0 : currentGame.id) ||
        !(currentGame === null || currentGame === void 0 ? void 0 : currentGame.title))
        return null;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.inner },
            withHeader && (react_1.default.createElement("div", { className: styles_module_scss_1.default.header },
                react_1.default.createElement("h1", null, t('activityScreenHeader')))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
                react_1.default.createElement(Tournament_1.default, { tournamentToShow: tournamentToShow, activeTournament: activeTournament }),
                react_1.default.createElement(TotalJackpot_1.default, { onClickJackpotHandler: onClickJackpotHandler, data: jackpotData }),
                react_1.default.createElement(WinOfTheMonth_1.default, { currentGame: currentGame, winData: winData })))));
};
exports.default = Activity;
